real.uid = function() {
    return ('aaaaaa' + Math.random().toString(36).replace(/[^a-z]+/g, '').substring(0,5)).slice(-6)
         + ('0000000000' + Math.random().toString().substring(2)).slice(-10);
};